// Dentro da Análise de Mercado 3.0 a licitação abre na rota própria; no Mercado, na dele.
export const linkDaLicitacao = (id: number | string | undefined) =>
  window.location.pathname.indexOf('/pesquisa_de_precos') === 0
    ? `/pesquisa_de_precos/licitacao/${id}`
    : `/mercado/bidding/${id}`;
